export default __webpack_public_path__ + "static/media/easyNine.ef11e3a6.png";